import React from 'react'
import ReactWhatsapp from 'react-whatsapp';

const Whatsapp = () => {
    return (
              <>
            <section className="content-header">
                <h1><i className="fa fa-envelope"></i> Whatsapp</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Send us a message</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            <div className="panel-body">
                                <div className="contact-container">
                                    <ReactWhatsapp number="233244608611" message="Hello World!!!" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>



  )
}

export default Whatsapp
